// theme.js - small module to manage light/dark theme
export function initTheme() {
    try {
        function setTheme(themeName) { localStorage.setItem('renius_theme', themeName); document.documentElement.className = themeName; }
        function toggleTheme() { if (localStorage.getItem('renius_theme') === 'theme-dark') { setTheme('theme-light'); } else { setTheme('theme-dark'); } }
        // Expose toggle globally for inline onchange handlers (legacy markup)
        window.toggleTheme = toggleTheme;
        (function () { if (localStorage.getItem('renius_theme') === 'theme-dark') { setTheme('theme-dark'); } else { setTheme('theme-light'); } })();
    } catch (err) { /* noop */ }
}
